export enum ProtocoloChamado {
    REQUEST_INVALIDO = 1100,
    CONTROLE_SALVO = 1201,
    DATAHEALTH_ASSOCIADO = 1202,
    DATAHEALTH_NAO_ENCONTRADO = 1203,
    CONTROLE_ALTERADO = 1204,
    CONTROLE_NAO_ENCONTRADO = 1205
}
export default ProtocoloChamado;
